import React, { Component } from 'react';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import ImagesUpload from '../../Components/Images-Upload/Images-Upload';
import CardHighlightDetails from '../../Components/Card-Highlight-Details/Card-Highlight-Details';
import DivPermission from '../../Components/Div-Permission/Div-Permission';
import Usuario from '../../Utils/Usuario';
import ImagemFukyo from '../../Components/Imagem-Fukyo/Imagem-Fukyo';

class AdvertisingDetails extends Component {

    constructor(props) {
        super(props);


        this.salvaNovoAnuncio = this.salvaNovoAnuncio.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.publishDateChange = this.publishDateChange.bind(this);
        this.habilitaSalvarBtn = this.habilitaSalvarBtn.bind(this);
        this.toggleChangeDestaque = this.toggleChangeDestaque.bind(this);
        this.redirecionaListaAnuncios = this.redirecionaListaAnuncios.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.apiAnuncio = this.apiAnuncio.bind(this);
        this.salvarDestaque = this.salvarDestaque.bind(this);
        this.toggleModalImagemDestaque = this.toggleModalImagemDestaque.bind(this);
        this.exibeDestaque = this.exibeDestaque.bind(this);
        this.scrollToElement = this.scrollToElement.bind(this);
        this.onChangeInputDestaque = this.onChangeInputDestaque.bind(this);
        this.carregaInfosDestaques = this.carregaInfosDestaques.bind(this);


        this._publishDateFocusChange = this.handleFocusChange('publishDate').bind(this);


        this.Configurations = new Configurations();

        this.state = {

            sucessoAlteracao: false,
            temAlteracao: false,
            isLoadingAnuncio: false,
            veiculo: '',
            imagem: '',
            link: '',
            dtInicio: '',
            dtFim: '',
            flagDestaque: false,
            openModal: false,
            hasError: false,
            errorMessage: '',
            novoAnuncio: this.props.match.params.idAnuncio === "novo-anuncio",
            flagDestaqueBSMais: false,
            flagDestaqueHub: false,
            modalCadastrarDestaque: false,
            tituloDestaque: '',
            descricaoDestaque: '',
            openModalImagemDestaque: false,
            imagemDestaque: '',
            exibeDestaque: false,
            isLoadingDestaque: false,
            sucessoDestaque: false,

        }

    }

    _outsideRange(day) {

        return false;
    }

    handleFocusChange(attr) {
        return function (focusedInput) {
            var dates = this.state.filters[attr];

            dates.focusedInput = focusedInput;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }
    publishDateChange(dt) {

        this.setState({

            dtInicio: dt.startDate,
            dtFim: dt.endDate,
        });
    }

    handleOnChange(e) {
        e.preventDefault();
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSelectChange(e) {
        this.setState({
            veiculo: e.target.value,
        })
    }

    salvaNovoAnuncio() {
        this.setState({ isLoadingAnuncio: true });
        const bodyPubli = {
            "veiculo": this.state.veiculo,
            "imagem": this.state.imagem,
            "link": this.state.link,
            "dtInicio": this.state.dtInicio.format('DD/MM/YYYY'),
            "dtFim": this.state.dtFim.format('DD/MM/YYYY'),
            "destaque": this.state.flagDestaque,
        }
        if (this.state.novoAnuncio === true) {
            axios.post(this.Configurations.apiBasePath + '/publicidades', bodyPubli).then(response => {
                this.toggleModal();
            }).catch(this.handleError).finally(() => this.setState({ isLoadingAnuncio: false }));

        }
        else {
            axios.put(this.Configurations.apiBasePath + `/publicidades/${this.props.match.params.idAnuncio}`, bodyPubli).then(response => {
                this.toggleModal();
            }).catch(this.handleError).finally(() => this.setState({ isLoadingAnuncio: false }));
        }
    }

    toggleChangeDestaque() {
        this.setState({
            flagDestaque: !this.state.flagDestaque
        });

    }

    redirecionaListaAnuncios() {
        this.props.history.push(`/publicidades`)
    }

    habilitaSalvarBtn() {

        const dtInicioValido = this.state.dtInicio !== '' && this.state.dtInicio.isValid();
        const dtFimValido = this.state.dtFim !== '' && this.state.dtFim.isValid();
        const imagemValida = this.state.imagem.trim() !== '';
        const linkValido = this.state.link.trim() !== '';

        return dtInicioValido && dtFimValido && imagemValida && linkValido
    }
    toggleModal() {
        if (this.state.openModal === true) {
            this.setState({
                openModal: false
            })
            this.redirecionaListaAnuncios();
        }
        else {
            this.setState({
                openModal: true
            })

        }
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.msg : 'Erro inesperado.' })
    }

    closeErrorModal() {
        this.setState({ hasError: false, errorMessage: "" })
    }

    componentDidMount() {
        if (!this.state.novoAnuncio) {
            this.apiAnuncio();
        }
    }

    apiAnuncio() {
        this.setState({ isLoadingAnuncio: true });
        axios.get(this.Configurations.apiBasePath + `/publicidades/${this.props.match.params.idAnuncio}`).then(response => {
            const publicidade = response.data.publicidade
            this.setState({
                publicidade: publicidade,
                veiculo: !!(publicidade.veiculo) ? publicidade.veiculo : '',
                dtInicio: moment(publicidade.dtInicio),
                dtFim: moment(publicidade.dtFim),
                imagem: publicidade.imagem,
                link: publicidade.link,
                flagDestaqueBSMais: publicidade.destaqueBSMais,
                flagDestaqueHub: publicidade.destaqueHub,
                tituloDestaqueBSMais: publicidade.destaqueBSMais ? undefined : publicidade.titulo,
                tituloDestaqueHub: publicidade.destaqueHub ? undefined : publicidade.titulo,
                descricaoDestaqueBSMais: publicidade.destaqueBSMais ? undefined : publicidade.descricao,
                descricaoDestaqueHub: publicidade.destaqueHub ? undefined : publicidade.descricao,
                linkDestaqueBSMais: publicidade.destaqueBSMais ? undefined : publicidade.link,
                linkDestaqueHub: publicidade.destaqueHub ? undefined : publicidade.link,
                imagemDestaqueBSMais: publicidade.destaqueBSMais ? undefined : publicidade.imagem,
                imagemDestaqueHub: publicidade.destaqueHub ? undefined : publicidade.imagem,
                idDestaqueBSMais: publicidade.idDestaqueBSMais,
                idDestaqueHub: publicidade.idDestaqueHub,
                exibeDestaqueBSMais: publicidade.destaqueBSMais,
                exibeDestaqueHub: publicidade.destaqueHub
            })

        }).catch(this.handleError).finally(() => this.setState({ isLoadingAnuncio: false }));

    }

    toggleModalImagemDestaque() {
        this.setState({ openModalImagemDestaque: !this.state.openModalImagemDestaque })
    }

    salvarDestaque() {
        if (!this.state.flagDestaqueBM) {
            const _salvarDestaque = {
                "tipo": 5,
                "titulo": this.state.tituloDestaque,
                "descricao": this.state.descricaoDestaque,
                "imagem": this.state.imagemDestaque,
                "idPublicidade": this.props.match.params.idAnuncio,
                "sigla": "PU",
                "link": this.state.linkDestaque,
            };
            this.setState({ isLoadingDestaque: true });

            axios.post(this.Configurations.apiBasePath + `/destaques/novo-destaque/1`, _salvarDestaque)
                .then(response => { this.apiAnuncio(); this.setState({ sucessoDestaque: true }) })
                .catch(this.handleError)
                .finally(() => { this.setState({ isLoadingDestaque: false }); });
        }
        else {
            this.setState({ isLoadingDestaque: true });
            const { tituloDestaque, descricaoDestaque, imagemDestaque, linkDestaque } = this.state;

            const _body = {
                titulo: tituloDestaque.trim() ? tituloDestaque : undefined,
                descricao: descricaoDestaque.trim() ? descricaoDestaque : undefined,
                imagem: imagemDestaque.trim() ? imagemDestaque : undefined,
                link: linkDestaque.trim() ? linkDestaque : undefined,
                tipo: 5
            };

            axios.put(this.Configurations.apiBasePath + `/destaques/${this.state.idDestaque}/1`, _body)
                .then(response => { this.apiAnuncio(); this.setState({ sucessoDestaque: true }) })
                .catch(this.handleError)
                .finally(() => this.setState({ isLoadingDestaque: false }));
        }
    }

    onChangeInputDestaque(e) {
        const { name, value } = e.target;
        if (name === "imagem") this.setState({ imagemDestaque: value, sucessoDestaque: false })
        else this.setState({ [name]: value, sucessoDestaque: false, });
    }

    exibeDestaque(plataforma) {
        this.setState({ ['exibeDestaque' + plataforma]: true }, () => this.scrollToElement('informacoesDestaque' + plataforma))
    }

    scrollToElement(id) {
        var element = document.getElementById(id);
        if (!!element) element.scrollIntoView({ block: "end", behavior: "smooth" });
    }

    carregaInfosDestaques() {
        this.setState({ isLoadingDestaque: true })
        axios.get(this.Configurations.apiBasePath + `/destaques/${this.state.idDestaque}/1`).then(response => {
            const { titulo, descricao, imagem, link } = response.data.data;
            this.setState({
                tituloDestaque: titulo,
                descricaoDestaque: descricao,
                imagemDestaque: imagem,
                linkDestaque: link,
            })
        }).catch(this.handleError).finally(() => this.setState({
            isLoadingDestaque: false
        }));
    }

    render() {
        return (
            <div className="row no-gutters novo-anuncio">
                <div className="col-12 novo-anuncio">
                    <div className="row no-gutters ">
                        <div className="col-lg-6 col-12 text-lg-left  text-center">
                            <h3 className="d-lg-block d-none">{this.state.novoAnuncio ? 'Novo' : 'Edição de'} Anúncio</h3>
                            <h5 className="d-lg-none">{this.state.novoAnuncio ? 'Novo' : 'Edição de'} Anúncio</h5>
                        </div>
                        <div className="col-lg-6 col-12 text-lg-right text-center">
                            <button className="btn btn-outline-secondary mx-2 my-2" type="button" name="voltar" onClick={() => this.props.history.push(`/publicidades`)}>
                                Voltar
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 px-lg-3">
                            <div className="card mt-3 mt-lg-0">
                                <div className="card-header text-center text-lg-left">
                                    <p className="m-0">Informações do Anúncio</p>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        {/* Layout desktop */}
                                        <div className="col-12 d-none d-lg-block">
                                            <div className="row no-gutters">
                                                <div className="col-4 py-3">
                                                    <small><small>(*)</small> informações obrigatórias</small>
                                                </div>
                                                {!this.state.isLoadingDestaqueBSMais && !this.state.isLoadingDestaqueHub && (
                                                    <DivPermission
                                                        arrayPerm={[1, 20]}
                                                        permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                                    >
                                                        <div className="col-8 text-right py-3">
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="row">
                                                                        <div className="col-6 text-center">
                                                                            <div className="row">
                                                                                <div className="col-12 text-center">
                                                                                    {this.state.flagDestaqueBSMais && (
                                                                                        <span className="badge badge-verdeBM badge-destaque">Esse item é um destaque BS+</span>
                                                                                    )}
                                                                                </div>
                                                                                <div className="col-12 mt-3 text-center">
                                                                                    <button className="btn btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("BSMais")}>{this.state.flagDestaqueBSMais ? 'editar destaque' : 'cadastrar como destaque BS+'}</button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-6 text-center">
                                                                            <div className="row">
                                                                                <div className="col-12 text-center">
                                                                                    {this.state.flagDestaqueHub && (
                                                                                        <span className="badge badge-purple badge-destaque">Esse item é um destaque HUB</span>
                                                                                    )}
                                                                                </div>
                                                                                <div className="col-12 mt-3 text-center">
                                                                                    <button className="btn btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("Hub")}>{this.state.flagDestaqueHub ? 'editar destaque' : 'cadastrar como destaque HUB'}</button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </DivPermission>

                                                )}
                                            </div>
                                        </div>
                                        {/* Layout mobile */}
                                        <div className="col-12 d-lg-none">
                                            <div className="row">
                                                {!this.state.isLoadingDestaqueBSMais && !this.state.isLoadingDestaqueHub && (
                                                    <DivPermission
                                                        arrayPerm={[1, 20]}
                                                        permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                                    >
                                                        <div className="col-12 text-right py-3">
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="row">
                                                                        <div className="col-6 text-center">
                                                                            <div className="row">
                                                                                <div className="col-12 text-center">
                                                                                    {this.state.flagDestaqueBSMais && (
                                                                                        <span className="badge badge-verdeBM badge-destaque">Destaque BS+</span>
                                                                                    )}
                                                                                </div>
                                                                                <div className="col-12 mt-3 text-center">
                                                                                    <button className="btn btn-sm btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("BSMais")}>{this.state.flagDestaqueBSMais ? 'editar' : 'cadastrar destaque BS+'}</button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-6 text-center">
                                                                            <div className="row">
                                                                                <div className="col-12 text-center">
                                                                                    {this.state.flagDestaqueHub && (
                                                                                        <span className="badge badge-purple badge-destaque">Destaque HUB</span>
                                                                                    )}
                                                                                </div>
                                                                                <div className="col-12 mt-3 text-center">
                                                                                    <button className="btn btn-sm btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("Hub")}>{this.state.flagDestaqueHub ? 'editar' : 'cadastrar destaque HUB'}</button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </DivPermission>
                                                )}
                                                <div className="col-12 col-lg-4 py-3">
                                                    <small><small>(*)</small> informações obrigatórias</small>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 col-lg-7">
                                            <div className="row">
                                                <div className="col-6 col-lg-3">
                                                    <div className="form-group">
                                                        <label htmlFor="veiculo">Veículo</label>
                                                        <select className="form-control mx-2" value={this.state.veiculo} onChange={this.handleSelectChange}>
                                                            <option></option>
                                                            <option>BS</option>
                                                            <option>TC</option>
                                                            <option>RD</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-9">
                                                    <label htmlFor="dpStartDate">Data de publicação<sup><small>(*)</small></sup></label><br />
                                                    <DateRangePicker
                                                        showClearDates
                                                        enableOutsideDays
                                                        isOutsideRange={this._outsideRange}
                                                        startDate={this.state.dtInicio} // momentPropTypes.momentObj or null,
                                                        startDateId="dpStartDate" // PropTypes.string.isRequired,
                                                        endDate={this.state.dtFim} // momentPropTypes.momentObj or null,
                                                        endDateId="dpEndDate"  // PropTypes.string.isRequired,
                                                        onDatesChange={this.publishDateChange} // PropTypes.func.isRequired,
                                                        focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                        onFocusChange={focusedInput => this.setState({ focusedInput })}
                                                        displayFormat="DD/MM/YYYY"
                                                        startDatePlaceholderText="Data inicial"
                                                        endDatePlaceholderText="Data final"
                                                        readOnly={true}

                                                    />
                                                </div>
                                                <div className="col-12 col-lg-11 px-3 py-3">
                                                    <label>Imagem<sup><small>(*)</small></sup></label>
                                                    <input autoComplete="off" name="imagem" className="form-control" type="text" value={this.state.imagem} onChange={this.handleOnChange} />
                                                </div>
                                                <div className="col-12  col-lg-11 px-3 py-3">
                                                    <label>Link<sup><small>(*)</small></sup></label>
                                                    <input autoComplete="off" name="link" className="form-control" type="text" value={this.state.link} onChange={this.handleOnChange} />
                                                </div>
                                                {/* <div className="col-12 col-lg-12 px-lg-5 py-lg-5 px-5 py-2 custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" id="destaque"
                                                    flagDestaque={this.state.flagDestaque}
                                                    onChange={this.toggleChangeDestaque}
                                                />
                                                <label class="custom-control-label" for="destaque">Destaque</label>
                                            </div> */}
                                            </div>
                                        </div>


                                        <div className="col-12 col-lg-5 d-flex align-items-center">
                                            <div className="row">
                                                <div className="col-12 m-0 py-3">
                                                    {!!this.state.imagem && <ImagemFukyo src={this.state.imagem} alt="imagem do anúncio" className="img img-fluid img-anuncio" />}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 col-lg-12 py-3 text-center text-lg-right" >
                                            {this.state.isLoadingAnuncio ? (
                                                <div className="spinner-border text-primary" role="status" />
                                            ) : (

                                                <button onClick={this.salvaNovoAnuncio} disabled={!this.habilitaSalvarBtn()} className="btn btn-outline-success">salvar</button>

                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.exibeDestaqueBSMais && (
                        <DivPermission
                            arrayPerm={[1, 20]}
                            permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                        >
                            <div className="row mt-5 informacoes-destaque" id="informacoesDestaqueBSMais">
                                <CardHighlightDetails
                                    tipoDestaque={5}
                                    idDestaque={this.state.idDestaqueBSMais}
                                    match={this.props.match}
                                    apiConteudo={this.apiAnuncio}
                                    plataforma={1}
                                    sigla={"PU"}
                                    itemConteudo={this.state.publicidade}
                                    flagDestaque={this.state.flagDestaqueBSMais}
                                />
                            </div>
                        </DivPermission>
                    )}

                    {this.state.exibeDestaqueHub && (
                        <DivPermission
                            arrayPerm={[1, 20]}
                            permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                        >
                            <div className="row mt-5 informacoes-destaque" id="informacoesDestaqueHub">
                                <CardHighlightDetails
                                    tipoDestaque={5}
                                    idDestaque={this.state.idDestaqueHub}
                                    match={this.props.match}
                                    apiConteudo={this.apiAnuncio}
                                    plataforma={2}
                                    sigla={"PU"}
                                    itemConteudo={this.state.publicidade}
                                    flagDestaque={this.state.flagDestaqueHub}
                                />
                            </div>
                        </DivPermission>
                    )}

                    <Modal className="modal-upload-imagem" size="lg" isOpen={this.state.openModalImagemDestaque} toggle={this.toggleModalImagemDestaque}>
                        <ModalHeader toggle={this.toggleModalImagemDestaque}>
                            Upload de imagem - Destaque
                        </ModalHeader>
                        <ModalBody>
                            <ImagesUpload toggle={this.toggleModalImagemDestaque} onChangeInput={this.onChangeInputDestaque}
                            />
                        </ModalBody>
                    </Modal>

                    <Modal className="modal-advertising-success" isOpen={this.state.openModal} toggle={this.toggleModal}>
                        <ModalHeader toggle={this.toggleModal}>
                            <div className="col-12 d-none d-lg-block px-0">
                                Efetivação da Publicidade
                            </div>
                        </ModalHeader>
                        <ModalBody>
                            Publicidade {this.state.novoAnuncio ? 'cadastrada' : 'atualizada'}  com sucesso!
                        </ModalBody>
                        <ModalFooter>
                            <Button color="success" onClick={this.redirecionaListaAnuncios} >ok</Button>
                        </ModalFooter>
                    </Modal>
                    <ErrorModal
                        isOpen={this.state.hasError}
                        message={this.state.errorMessage}
                        closeErrorModal={this.closeErrorModal}
                    />
                </div>
            </div>
        )
    }

}


export default AdvertisingDetails;